import { get } from "lodash"
import { track } from "./lib/analytics"

const trackPromoEvent = (event, promo) => {
  const campaignName = get(promo, ["campaign", "name"])

  if (event && promo.type && promo.promoId && campaignName) {
    track(promo.type, `${event} - Promo #${promo.promoId}`, campaignName, 1)
  }
}

export const trackImpression = (promo) => {
  trackPromoEvent("Impression", promo)
}

export const trackDismiss = (promo) => {
  trackPromoEvent("Dismiss", promo)
}

export const trackEngagement = (promo) => {
  trackPromoEvent("Engagement", promo)
}
